import api from '@/api/'

export const strategyCommand = {
  edit(data) {
    this.$router.push(`/template/edit/${data.id}`)
  },
  async state(data) {
    const _this = this
    const state = data.state
    this.$confirm({
      content: `确定要${state === 1 ? '禁用' : '启用'}吗？`,
      okText: '确定',
      cancelText: '取消',
      async onOk() {
        const res = await api.updateStateTemplate({ id: data.id, state: state === 1 ? 2 : 1 })
        if (_this.$validate(res)) {
          _this.$message.success(`${state === 1 ? '禁用' : '启用'}成功~`)
          _this.getList()
        }
      }
    })
  },
  delete(data) {
    const _this = this
    this.$confirm({
      content: '确定要删除吗？',
      okText: '确定',
      cancelText: '取消',
      async onOk() {
        const res = await api.deleteTemplate({ id: data.id })
        if (_this.$validate(res)) {
          _this.$message.success('删除成功~')
          _this.getList()
        }
      }
    })
  }
}
